import { Injectable, Output } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { FormBuilder, FormArray } from '@angular/forms'
import { Team } from '../../../core/models/team.model'
import { Banner } from '../../../core/models/metrics.model'
import { EventEmitter } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class StreamService {
  @Output() bannerUpdatedEvent = new EventEmitter<Banner>()

  BannerUpdated(banner: Banner){
    this.bannerUpdatedEvent.emit(banner)
  }

  constructor(
    private http: HttpClient,
    private fb:FormBuilder, 
  ) {
    this.addArrayRecords()
  }

  match = this.fb.group({
    competition: [''],
    local: this.fb.control<Team | null>(null),
    local_goals: [0],
    away: this.fb.control<Team | null>(null),
    away_goals: [0]
  })

  calendar = this.fb.group({
    matches: this.fb.array([])
  })

  get matches(): FormArray {
    return this.calendar.get('matches') as FormArray
  }
  
  addArrayRecords(){
    for (let i = 0; i < 4; i++) {
      this.matches.push(this.fb.group({
        team: this.fb.control<Team | null>(null),
        venue: [''],
        date: this.fb.control<Date | null>(null),
        competition: ['']
      }))
    }
  }

  readonly authURL = environment.DOMAIN_URL+'/api/auth/'

  enviar(){
    return this.http.get(this.authURL+'earlyaccess')
    .pipe(catchError(this.errorHandler))
  }

  readonly baseURL = environment.DOMAIN_URL+'/api/stream/'

  get(){
    return this.http.get(this.baseURL)
    .pipe(catchError(this.errorHandler))
  }

  getBannersData(){
    return this.http.get(this.baseURL+'data')
    .pipe(catchError(this.errorHandler))
  }

  save(filters:any, metrics:any){
    return this.http.post(this.baseURL, {filters,metrics})
    .pipe(catchError(this.errorHandler))
  }

  saveCalendar(){
    return this.http.post(this.baseURL, {calendar: this.calendar.getRawValue()})
    .pipe(catchError(this.errorHandler))
  }

  saveMatch(){
    return this.http.post(this.baseURL, {match: this.match.getRawValue()})
    .pipe(catchError(this.errorHandler))
  }

  remove(id:string){
    return this.http.delete(this.baseURL+id)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }
}
